import { type ReactNode } from 'react';
import { GreenLiquidGlassButton } from './GreenLiquidGlassButton';

interface PrimaryButtonProps {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  className?: string;
  type?: 'button' | 'submit';
}

export function PrimaryButton({
  children,
  onClick,
  disabled,
  loading,
  fullWidth = true,
  className,
  type = 'button',
}: PrimaryButtonProps) {
  return (
    <GreenLiquidGlassButton
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      loading={loading}
      fullWidth={fullWidth}
      className={className}
    >
      {children}
    </GreenLiquidGlassButton>
  );
}
